import React from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV3';
import { isValid } from 'date-fns';

import styles from './date.style';

const DateComponent = ({
  value,
  name,
  error,
  onChange,
  disablePortal = false,
  ...rest
}) => {
  const handleChange = (newValue) => {
    if (newValue && newValue instanceof Date && isValid(newValue)) {
      onChange(newValue.toISOString());
    } else {
      onChange(newValue);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        showToolbar={false}
        format="dd-MM-yyyy"
        slotProps={{
          popper: {
            disablePortal,
            sx: styles.popper,
          },

          textField: {
            'data-testid': `input-${name}`,
            variant: 'outlined',
            error: !!error,
            sx: {
              ...styles.textfield,
              ...(!!error && styles.errorTextInput),
            },
          },
        }}
        value={value ? new Date(value) : null}
        onChange={handleChange}
        {...rest}
        label=""
      />
    </LocalizationProvider>
  );
};

export default DateComponent;
